
const style = {
    RemoveComment: {

    }
}

export default style